import type { FC } from 'react';
import type { SequenceLayout } from './layout-sequence';
import { SequenceText } from './SequenceText';
import { TITLE_FONT_SIZE, sequenceColors } from './sequence-constants';
import { FontWeight } from '@/theme/typography';

const SEQUENCE_TITLE_ALIGN = 'center';
const SEQUENCE_TITLE_HEIGHT_EXTRA = 6;

interface SequenceTitleProps {
  layout: SequenceLayout;
}

export const SequenceTitle: FC<SequenceTitleProps> = ({ layout }) => {
  if (layout.titleY == null || !layout.title) {
    return null;
  }

  return (
    <SequenceText
      x={0}
      y={layout.titleY - TITLE_FONT_SIZE}
      width={layout.width}
      height={TITLE_FONT_SIZE + SEQUENCE_TITLE_HEIGHT_EXTRA}
      content={layout.title}
      size={TITLE_FONT_SIZE}
      weight={FontWeight.Bold}
      color={sequenceColors.headerText}
      align={SEQUENCE_TITLE_ALIGN}
    />
  );
};
